import { getENV } from '@libs/common-next';
import { ItemUI } from '@libs/common-node';

import { useProduct } from '@/entities/product';
import type { EEaddToCartEvent } from '@/shared/analytics';
import { dataLayerPush } from '@/shared/analytics';

type SendAnalyticsProps = {
    products: ItemUI[];
};

export const useAddToCartEE = () => {
    const { product, base, tailored } = useProduct();

    const sendAnalyticsEE = ({ products }: SendAnalyticsProps) => {
        if (!product || !base || !tailored) return;

        const isCA = getENV('NEXT_PUBLIC_LOCALE') === 'en-CA';

        const { categories, merchandisingHierarchy } = base;
        const tailoredBopisStoreId = tailored.variants?.[product.sku].BOPIS?.storeId;

        const productsEE = products.map(product => {
            const isRxMed = product.pharmacyType === 'rx_med' && product.customCaseQuantity;

            return {
                name: product.name,
                id: product.sku,
                brand: product?.merchandiseBrand ?? '',
                price: product.basePrice,
                quantity: 1,
                dimension5: product.pharmacyType ?? 'Other',
                dimension6: 'Recommendation',
                dimension9: categories[0] ?? '',
                dimension10: categories[1] ?? '',
                dimension11: categories[2] ?? '',
                dimension12: 'bopis',
                dimension13: null,
                dimension14: tailoredBopisStoreId?.padStart(4, '0') || '',
                dimension18: product?.variant?.color ?? '',
                dimension19: product?.variant?.size ?? '',
                dimension20: product?.variant?.flavor ?? '',
                dimension21: isRxMed ? String(product.customCaseQuantity) : null,
                dimension41: merchandisingHierarchy?.vicePresidentName ?? '',
                dimension42: merchandisingHierarchy?.division ?? '',
                dimension43: merchandisingHierarchy?.department ?? '',
                dimension44: merchandisingHierarchy?.class ?? '',
                dimension45: merchandisingHierarchy?.category ?? '',
                dimension133: 'PFM - Product Recs Add to Cart',
            };
        }) satisfies Exclude<EEaddToCartEvent['ecommerce'], null>['add']['products'];

        // Clear ecommerce object to prevent GTM from sending stale values with new events
        dataLayerPush({ ecommerce: null });

        dataLayerPush({
            event: 'EEaddToCart',
            ecommerce: {
                currencyCode: isCA ? 'CAD' : 'USD',
                add: {
                    products: productsEE,
                    actionField: { list: 'PFM - Product Recs Add to Cart' },
                },
            },
        });
    };

    return { sendAnalyticsEE };
};
